import { injectQualtricsScript } from '@highmark-web/highmark-common';

const QUALTRICS_LIVE_CHAT_INTERCEPTOR_ELEMENT_ID = 'ZN_3kGXD684eECoKvc';
const QUALTRICS_LIVE_CHAT_INTERCEPTOR_COOKIE_ID = 'QSI_S_ZN_3kGXD684eECoKvc';
const QUALTRICS_LIVE_CHAT_INTERCEPTOR_SRC =
  'https://zn3kgxd684eecokvc-highmark.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_3kGXD684eECoKvc';

export function injectLiveChatQualtricsScript() {
  injectQualtricsScript({
    elementId: QUALTRICS_LIVE_CHAT_INTERCEPTOR_ELEMENT_ID,
    cookieId: QUALTRICS_LIVE_CHAT_INTERCEPTOR_COOKIE_ID,
    src: QUALTRICS_LIVE_CHAT_INTERCEPTOR_SRC,
  });
}
